var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"name-info-title"},[_vm._v(_vm._s(_vm.formatedNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }